module.exports = __webpack_public_path__ + "static/3-bb1856b865ab4033865d5bd72e9b3c28.jpg";